import { render, staticRenderFns } from "./GipTransfer.vue?vue&type=template&id=5da1574b"
import script from "./GipTransfer.vue?vue&type=script&lang=js"
export * from "./GipTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports